export default __webpack_public_path__ + "static/media/Metropolis-Bold.3b74274c.woff2";